import { reportData } from '@shakkerai/services';
import { getUserinfo } from '@shakkerai/business-userinfo';
import { getCookieWebid, getCookie } from '@shakkerai/util-cookie';

export const getRandomChars = (length = 8) => {
  const chars = 'abcdefghijklmnopqrstuvwxyz';
  let result = '';
  for (let i = length; i > 0; --i) {
    result += chars[Math.floor(Math.random() * chars.length)];
  }
  return result;
};

export const getCid = () => {
  let cid = getCookieWebid();

  return cid;
};

export const report = async (params) => {
  const { data: userInfo } = await getUserinfo();
  const obj = {
    uuid: userInfo?.uuid || '',
    cid: getCid(),
    ct: new Date().getTime(),
    pageUrl: location.href,
    ua: navigator.userAgent,
    ...params,
  };
  const sourceId = getCookie('attractSourceId');
  if (sourceId) {
    if (!obj.var) {
      obj.var = { source_id: sourceId };
    } else {
      obj.var.source_id = sourceId;
    }
  }
  return reportData(obj);
};

/**
 * 曝光
 * @param {*} eventName
 * @param {*} args
 */
export const mv = (eventName, args) => {
  report({
    e: eventName,
    var: args,
  });
};

/**
 * 事件
 * @param {*} eventName
 * @param {*} args
 */
export const mc = async (eventName, args) => {
  try {
    await report({
      e: eventName,
      var: args,
    });
  } catch {
    // 埋点上报出错不阻塞后续流程
  }
};
